export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-960-36cdfd991e04e9f3bc41335643414ff2.png";